import { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navigation from '../../Content/Data/Navigation/navigation.json';
import AmatyaConsultantsLogo from '../../Content/Images/Logo.png';

function TopNavbar(props) {

    const [arrNavigation, setNavigation] = useState(getNavigationJson());
    const nodeRef = useRef([]);

    useEffect(() => {
        setNavigation(getNavigationJson());
    }, [props.isPathChanged])

    function getNavigationJson() {
        return Navigation.map(x => {
            if (x.subMenu && x.subMenu.length > 0) {
                let isSeleted = false;
                let arrSubMenu = x.subMenu.map(y => {
                    if (y.subMenu && y.subMenu.length > 0) {
                        let isSubMenuSeleted = false;
                        let arrSubMenu2 = y.subMenu.map(z => {
                            if (!isSubMenuSeleted) {
                                isSubMenuSeleted = isActiveByDefault(z, y, x);
                            }
                            if (!isSeleted) {
                                isSeleted = isSubMenuSeleted;
                            }
                            return {
                                ...z,
                                "isSelected": isActiveByDefault(z, y, x)
                            };
                        });
                        return {
                            ...y,
                            "subMenu": arrSubMenu2,
                            "isSelected": isSubMenuSeleted
                        };
                    }
                    else {
                        if (!isSeleted) {
                            isSeleted = isActiveByDefault(y, x);
                        }
                        return {
                            ...y,
                            "isSelected": isActiveByDefault(y, x)
                        };
                    }
                });
                return {
                    ...x,
                    "subMenu": arrSubMenu,
                    "isSelected": isSeleted
                };
            }
            else {
                return {
                    ...x,
                    "isSelected": isActiveByDefault(x)
                };
            }
        });
    }

    function handleNavclick(item) {
        let arrData = arrNavigation.map(x => {
            if (x.subMenu && x.subMenu.length > 0) {
                let isSeleted = false;
                let arrSubMenu = x.subMenu.map(y => {
                    if (y.subMenu && y.subMenu.length > 0) {
                        let isSubMenuSeleted = false;
                        let arrSubMenu2 = y.subMenu.map(z => {
                            if (!isSubMenuSeleted) {
                                isSubMenuSeleted = z.id === item.id;
                            }
                            if (!isSeleted) {
                                isSeleted = isSubMenuSeleted;
                            }
                            return {
                                ...z,
                                "isSelected": z.id === item.id
                            };
                        });
                        return {
                            ...y,
                            "subMenu": arrSubMenu2,
                            "isSelected": isSubMenuSeleted
                        };
                    }
                    else {
                        if (!isSeleted) {
                            isSeleted = y.id === item.id;
                        }
                        return {
                            ...y,
                            "isSelected": y.id === item.id
                        };
                    }
                });
                return {
                    ...x,
                    "subMenu": arrSubMenu,
                    "isSelected": isSeleted
                };
            }
            else {
                return {
                    ...x,
                    "isSelected": x.id === item.id
                };
            }
        });
        nodeRef.current.map(x => { x.style.display = "none" });
        nodeRef.current = [];
        setNavigation(arrData);
        props.setIsPathChanged(!props.isPathChanged);
    }

    function isActiveByDefault(z, y, x) {
        let location = "/" + z.to;
        if (y) {
            location = "/" + y.to + "?a=" + z.to;
        }
        if (x) {
            location = "/" + x.to + "?a=" + y.to + "&b=" + z.to;
        }
        // if (document.location.hash === location) {
        // console.log("document.location", document.location);
        // console.log("location", location);
        //     return 1;
        // }
        if (document.location.pathname + document.location.search === location) {
            return 1;
        }
        return 0;
    }

    function handleTouchEvent(event) {
        let node;
        if (event.target.className.includes('fa-caret')) {
            node = event.target.parentElement;
        }
        else if (event.target.className.includes('nav-dropdown')) {
            node = event.target.firstChild;
        }
        else {
            node = event.target;
        }
        nodeRef.current.push(node.nextSibling);
        node.nextSibling.style.display = "flex";
        console.log(node);
    }

    return (
        <div className="navbar">
            <div className='nav-brand'>
                <img src={AmatyaConsultantsLogo} alt='AmatyaConsultants'></img>
            </div>
            <div className='nav-ham'>
                <button className='nav-ham-btn' onClick={() => { props.setOpenSideNavigation(!props.openSideNavigation) }}>
                    <i className="fa fa-bars"></i>
                </button>
            </div>
            <div className="nav">
                {
                    arrNavigation.map((x, i) => {
                        if (x.subMenu && x.subMenu.length > 0) {
                            return (
                                <div key={i} id={x.id} className='nav-container'>
                                    <div className="nav-dropdown">
                                        <button
                                            className={x.isSelected ? x.className + ' nav-dropbtn active-nav' : x.className + ' nav-dropbtn'}
                                            onTouchStart={(event) => { handleTouchEvent(event); }}
                                        >
                                            {x.name}
                                            &nbsp;<i className="fa fa-caret-down"></i>
                                        </button>
                                        <div className="nav-dropdown-content">
                                            {
                                                x.subMenu.map((y, j) => {
                                                    if (y.subMenu && y.subMenu.length > 0) {
                                                        return (
                                                            <div key={j} id={y.id} className='sub-nav-container'>
                                                                <div className="sub-nav-dropdown" >
                                                                    <button className={y.isSelected ? 'sub-nav-dropbtn active-nav' : 'sub-nav-dropbtn'} onTouchStart={(event) => { handleTouchEvent(event); }}>
                                                                        {y.name}
                                                                        <i className="float-right fa fa-caret-right"></i>
                                                                    </button>
                                                                    <div className="sub-nav-dropdown-content">
                                                                        {
                                                                            y.subMenu.map((z, k) => {
                                                                                return (
                                                                                    <Link key={k} id={z.id} className={z.isSelected ? z.className + ' active-nav-drop-link' : z.className} onClick={(event) => { handleNavclick(z) }} to={"/" + x.to + "?a=" + y.to + "&b=" + z.to}>{z.name}</Link>
                                                                                )
                                                                            })
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        );
                                                    }
                                                    else {
                                                        return (
                                                            <Link key={j} id={y.id} className={y.isSelected ? y.className + ' active-nav-drop-link' : y.className} onClick={(event) => { handleNavclick(y) }} to={"/" + x.to + "?a=" + y.to}>{y.name}</Link>
                                                        );
                                                    }
                                                })
                                            }
                                        </div>
                                    </div>
                                </div>
                            );
                        }
                        else {
                            return (
                                <Link key={i} id={x.id} className={x.isSelected ? x.className + ' active-nav' : x.className} onClick={(event) => { handleNavclick(x) }} to={"/" + x.to}>{x.name}</Link>
                            );
                        }
                    })
                }
            </div>
        </div>
    );
}

export default TopNavbar;
